module.exports = __webpack_public_path__ + "img/shipstation-logo.2acc11bb.png";